import { useContext } from 'react'
import BtnActionTable from '../../components/BtnActionTable'
import Button from '../../components/Button'
import Icon from '../../components/Icon'
import Option from '../../components/Option'
import Context from './context'
import { PropsActionActiveDeactive } from './types'

export default function Deactive({
    children,
    accept,
    label,
    notify = 'La operación se ha completado exitosamente',
    title = 'Desactivar registro',
    ...props
}: PropsActionActiveDeactive) {
    const { onClick, className, isEnabled, type, disabled, iconHide } =
        useContext(Context)
    if (!isEnabled) return null
    function handleClick() {
        onClick({
            ...props,
            title,
            notify,
            accept: accept || 'Sí, desactivar registro',
            message: children
        })
    }

    return (
        <>
            {!label && (
                <BtnActionTable
                    title="Desactivar"
                    iconName="bs-lock"
                    disabled={disabled}
                    onClick={handleClick}
                />
            )}
            {label && (
                <>
                    {type === 'option' && (
                        <Option
                            onClick={handleClick}
                            icon="bs-lock"
                            value="0"
                            label={label}
                            disabled={disabled}
                        />
                    )}
                    {type === 'button' && (
                        <Button
                            className={className}
                            onClick={handleClick}
                            size="sm"
                            color="neutral"
                            disabled={disabled}
                        >
                            {!iconHide && (
                                <Icon
                                    name="bs-lock"
                                    size={14}
                                    className="mr-1"
                                />
                            )}{' '}
                            {label}
                        </Button>
                    )}
                </>
            )}
        </>
    )
}
